import { render, staticRenderFns } from "./AddOrEditGroup.vue?vue&type=template&id=24f5b30e&scoped=true"
import script from "./AddOrEditGroup.vue?vue&type=script&lang=js"
export * from "./AddOrEditGroup.vue?vue&type=script&lang=js"
import style0 from "./AddOrEditGroup.vue?vue&type=style&index=0&id=24f5b30e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f5b30e",
  null
  
)

export default component.exports